import { render, staticRenderFns } from "./CompanionListView.vue?vue&type=template&id=416fc0e1&scoped=true"
import script from "./CompanionListView.vue?vue&type=script&lang=js"
export * from "./CompanionListView.vue?vue&type=script&lang=js"
import style0 from "./CompanionListView.vue?vue&type=style&index=0&id=416fc0e1&prod&scoped=true&lang=scss"
import style1 from "./CompanionListView.vue?vue&type=style&index=1&id=416fc0e1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416fc0e1",
  null
  
)

export default component.exports